import { createRoot } from "react-dom/client";
import posthog, { type CapturedNetworkRequest } from "posthog-js";
import App from "./App.tsx";
import "./index.css";

const SENSITIVE_HEADERS = new Set(["authorization", "apikey"]);

const stripSensitiveHeaders = (headers?: Record<string, string>) => {
  if (!headers) return headers;
  const cleaned: Record<string, string> = {};
  for (const [key, value] of Object.entries(headers)) {
    cleaned[key] = SENSITIVE_HEADERS.has(key.toLowerCase()) ? "[redacted]" : value;
  }
  return cleaned;
};

// Supabase's auth endpoints return the session (access_token/refresh_token) in
// the response body, and some requests carry a refresh_token in the request
// body — redact wholesale rather than trying to scrub individual JSON fields.
const isSupabaseAuthRequest = (url?: string) => !!url && /\/auth\/v1\//.test(url);

// Defense in depth: even if network request/header/body recording gets turned
// on remotely from the PostHog project dashboard, this still strips auth
// tokens before anything is captured in the session replay.
const maskCapturedNetworkRequestFn = (request: CapturedNetworkRequest): CapturedNetworkRequest => {
  const masked: CapturedNetworkRequest = {
    ...request,
    requestHeaders: stripSensitiveHeaders(request.requestHeaders),
    responseHeaders: stripSensitiveHeaders(request.responseHeaders),
  };

  if (isSupabaseAuthRequest(request.name)) {
    masked.requestBody = request.requestBody ? "[redacted]" : request.requestBody;
    masked.responseBody = request.responseBody ? "[redacted]" : request.responseBody;
  }

  return masked;
};

// Initialize PostHog (public project token — safe to commit)
posthog.init("phc_nChEmqVXvHYy5ar4v2gspdp5t2HJcbwQjNDueov5vnvT", {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  session_recording: {
    maskCapturedNetworkRequestFn,
  },
});

createRoot(document.getElementById("root")!).render(<App />);
